import {ResolvedGallery, ResolvedPhoto} from "../types";
import {
    loadGalleriesIndex, loadPhotosIndex,
    resolvePhotoYaml
} from "./contentSource";

export class GalleriesRepository {
    private _resolvedGalleries: Map<string, ResolvedGallery>;

    constructor(resolvedGalleries: Map<string, ResolvedGallery>) {
        this._resolvedGalleries = resolvedGalleries;
    }

    getGallery(id: string): ResolvedGallery {
        return this._resolvedGalleries.get(id)!;
    }

    getGalleries(): ResolvedGallery[] {
        return Array.from(this._resolvedGalleries.values());
    }
}

export class PhotosRepository {
    private _resolvedPhotos: Map<string, ResolvedPhoto>;

    constructor(resolvedPhotos: Map<string, ResolvedPhoto>) {
        this._resolvedPhotos = resolvedPhotos;
    }

    getPhoto(filename: string): ResolvedPhoto {
        return this._resolvedPhotos.get(filename)!;
    }
}

export async function buildPhotosRepository(): Promise<PhotosRepository> {
    const photosYaml = (await loadPhotosIndex());
    const resolvedPhotos = new Map<string, ResolvedPhoto>();
    photosYaml.photos.forEach(photo => {
        resolvedPhotos.set(photo.id, resolvePhotoYaml(photo));
    });
    return new PhotosRepository(resolvedPhotos);
}

export async function buildGalleriesRepository(photosRepository: PhotosRepository): Promise<GalleriesRepository> {
    const galleriesIndex = await loadGalleriesIndex();

    const resolvedGalleries: ResolvedGallery[] = galleriesIndex.galleries.map(g => {
        const photos = g.photosIds.map(filename => photosRepository.getPhoto(filename));
        return {
            id: g.id,
            title: g.title,
            cover: g.cover ? photosRepository.getPhoto(g.cover) : undefined,
            photos,
            galleries: []
        }
    });

    const galleryRepository = new GalleriesRepository(new Map(resolvedGalleries.map(g => [g.id, g])));

    galleriesIndex.galleries.forEach(galleryYaml => {
        const gallery = galleryRepository.getGallery(galleryYaml.id);
        const subgalleriesIds = galleryYaml.galleriesIds;
        subgalleriesIds.forEach(subgalleryId => {
            const subgallery = galleryRepository.getGallery(subgalleryId);
            gallery.galleries.push(subgallery);
        })

    });

    return galleryRepository;
}
